define('auth/auth',['durandal/app', 'jquery', 'plugins/router', 'knockout'], function (app, $, router) {

    var viewmodel = function () {
        var self = this;

        self.router = router;
        self.returnUrl = '/';
        
        self.activate = function () {
            $('html').addClass('login');
            
            var queryParams = self.router.activeInstruction().queryParams;

            if (queryParams && queryParams.returnUrl) {
                self.returnUrl = queryParams.returnUrl;
            }

            if (queryParams && queryParams.reason && queryParams.reason === 'noinvite') {
              app.showMessage("<p>You need an invitation to log in to this site with the email address '" + queryParams.email + "'.</p><p>If you have not received an invitation yet please contact your company administrator.</p>", "Login failed. Invitation required.");
            }

            if (window.location.hostname === 'localhost' || window.location.hostname === 'isos.mapforge.co.uk') {
                self.providers = [self.getProvider('Google', 'google'), self.getProvider('Okta', 'user') , self.getProvider('Linkedin', 'linkedin')];
            } else {
                self.providers = [self.getProvider('Google', 'google'), self.getProvider('Linkedin', 'linkedin')];
            }
        };
        
        self.getProvider = function (providerName, icon) {
            return {
                icon: icon,
                providerName: providerName,
                providerUrl: '/authentication/redirect/' + providerName + '?ReturnUrl=' + self.returnUrl
            };
        };

        self.emailogin = function (editorMap) {
            router.navigate('/authentication/email');
        };
    };

    return viewmodel;
});

